import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function Hero() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith("ar");
  const headline = t("hero.headline");
  const animatedPhrase = isRTL ? "من الألف إلى الياء" : "from A to Z";

  const renderAnimatedHeadline = () => {
    if (!headline.includes(animatedPhrase)) {
      return headline;
    }

    const [before, after] = headline.split(animatedPhrase);

    return (
      <>
        {before}
        <span className="hero-headline-loop-fill">{animatedPhrase}</span>
        {after}
      </>
    );
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[800px] flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <motion.img
          src="/assets/images/16.jpg"
          alt="Warehouse racking systems"
          className="w-full h-full object-cover object-top"
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-24 pt-40 md:pt-60">
        <div className="max-w-4xl">
          <motion.h1
            className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.25] md:leading-[1.2] lg:leading-[1.15] mb-6"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {renderAnimatedHeadline()}
          </motion.h1>
          <motion.p
            className="text-xl md:text-2xl text-white/80 max-w-2xl mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {t("hero.subheadline")}
          </motion.p>
          <motion.a
            href="/contact-us"
            className="inline-flex items-center gap-3 bg-brand text-white text-lg font-semibold px-8 py-4 rounded-full hover:bg-brand-dark transition-colors whitespace-nowrap cursor-pointer"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t("hero.cta")}
            <span className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
              <i className={`${isRTL ? "ri-arrow-left-line" : "ri-arrow-right-line"} text-white text-sm`} />
            </span>
          </motion.a>
        </div>
      </div>
    </section>
  );
}